import React from "react"
import { useLocation } from "react-router-dom";

function Page404() {

    const location = useLocation().pathname

    if (location == "/404") {
        return (
            <div id="page404">
                <h1 id="_404">404</h1>
                <h3>page not found</h3>
            </div>
        )
    } else {
        return (
            <div className="page">
                <div id="page404">
                    <h1 id="_404">404</h1>
                    <h3>page not found</h3>
                </div>
            </div>
        )
    }
}

export default Page404;